// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components-QuestionList-PracticeList-container-3f7Mw"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/QuestionList/PracticeList.css
 ** module id = 278
 ** module chunks = 0
 **/